// wrapperProps.ts
export default {
  disabled: Boolean,
  hideTip: Boolean,
  noWrapper: Boolean,
  okOnly: Boolean,
  showPremiumFeature: Boolean,
  smallerTitle: Boolean,
  title: {
    type: String,
    default: '',
  },
  subTitle: {
    type: String,
    default: '',
  },
  helpfulTip: {
    type: String,
    default: null,
  },
  premiumFeatureText: {
    type: String,
    default: '',
  },
}
